var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import { RouterLink } from "@irati/ui/src/Link";
import { Body } from "@irati/ui/src/Typography";
import noUsedPerks from "@irati/ui/images/no-used-perks.svg";
import { NoPerksImage } from "../styled/NoPerks";
var NoPerks = /** @class */ (function (_super) {
    __extends(NoPerks, _super);
    function NoPerks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoPerks.prototype.render = function () {
        var _a = this.props, usedPerksOptionActive = _a.usedPerksOptionActive, formatMessage = _a.formatMessage;
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Flex, { direction: "column", alignItems: "center" },
                    React.createElement(NoPerksImage, { src: noUsedPerks, alt: formatMessage({ id: "perks.myPerks.noUsedPerks.img.alt" }) }),
                    usedPerksOptionActive && (React.createElement(Body, { small: true },
                        React.createElement(FormattedMessage, { id: "perks.myPerks.noUsedPerks.para" })))),
                !usedPerksOptionActive && (React.createElement(Body, { id: "nothingFound", small: true, textAlign: "center" },
                    React.createElement(FormattedMessage, { id: "perks.myPerks.noPerks.emptyState.cta.text", values: {
                            link: (React.createElement(RouterLink, { cta: true, to: "/" },
                                React.createElement(FormattedMessage, { id: "perks.myPerks.noPerks.emptyState.cta.here" })))
                        } }))))));
    };
    return NoPerks;
}(PureComponent));
export default injectIntl(NoPerks);
